import React from 'react';
import { View, Text } from 'react-native';
import { useAdminThemeContext } from '../../contexts/AdminThemeContext';

export function AdminSectionHeader({ title, subtitle, isFirst = false }) {
  const { colors } = useAdminThemeContext();

  return (
    <View
      style={{
        marginTop: isFirst ? 0 : 36,
        marginBottom: 16,
        paddingBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: colors.divider,
      }}
    >
      <Text
        style={{
          fontSize: 20,
          fontWeight: '700',
          color: colors.textPrimary,
          fontFamily: 'VastagoGrotesk',
        }}
      >
        {title}
      </Text>
      {subtitle ? (
        <Text
          style={{
            fontSize: 13,
            color: colors.textSecondary,
            fontFamily: 'VastagoGrotesk',
            marginTop: 4,
            lineHeight: 18,
          }}
        >
          {subtitle}
        </Text>
      ) : null}
    </View>
  );
}
